require('swiper');
//plugins
import './plugins/swiper';
import './plugins/pulltorefresh';

require('./bootstrap');
require('micromodal');
require('autosize');

import '@fortawesome/fontawesome-free/js/fontawesome';
import '@fortawesome/fontawesome-free/js/solid';
import '@fortawesome/fontawesome-free/js/regular';
import '@fortawesome/fontawesome-free/js/brands';
import 'jquery-jpostal-ja';

//common
import './plugins/modal';
import './plugins/hiraku';
import './plugins/autosize';
import './plugins/matchHeight-min';
import './plugins/flatpickr';


import './common/city';
import './common/form';
import './common/script';
import './common/file-upload';
import './common/send-message';
import './common/send-rate';
import './common/jpostal';
import './common/job-notification-setting';
import './message/index';

//signup
import './signup/common';

//shop-mypage
import './shop/job-offers/create'; //求人情報の登録

// 求人情報詳細
import './job-offers/detail';

// 美容師免許有無
import './elements/forms/input/flg_beautician_license';

import './elements/forms/shop/script'; //スポットバイトを探す
import './elements/commom_parts/header'; //header

//グーグルマップ操作
import './search/init-map';

//子ページ
import './page/script';
